import * as VerdiWebClient from "verdi-web-client";

export function setGoogleAnalyticsTags() {
    if (!VerdiWebClient.SessionHandler.admin) {
        // @ts-ignore
        // eslint-disable-next-line no-undef
        gtag("config", "G-VNS3BXM4PJ", {
            user_id: VerdiWebClient.SessionHandler.admin ? "ADMIN" : VerdiWebClient.SessionHandler.curUser,
            groups: VerdiWebClient.SessionHandler.admin ? "ADMIN" : "customer",
        });
        // @ts-ignore
        // eslint-disable-next-line no-undef
        gtag("set", {
            user_id: VerdiWebClient.SessionHandler.admin ? "ADMIN" : VerdiWebClient.SessionHandler.curUser,
            client_id: VerdiWebClient.SessionHandler.admin ? "ADMIN" : VerdiWebClient.SessionHandler.curUser,
            admin: VerdiWebClient.SessionHandler.admin,
            user_agent: window.navigator.userAgent,
        });
    }
}
